import { Box, Paper, Typography } from "@mui/material";
import React from "react";

export const GraphLegend: React.FC = () => {
  const nodeTypes = [
    {
      type: "organization",
      color: "#2196F3",
      icon: "🏢",
      label: "Organizations",
    },
    { type: "facility", color: "#4CAF50", icon: "🏭", label: "Facilities" },
    { type: "project", color: "#FF9800", icon: "📋", label: "Projects" },
    { type: "source", color: "#9C27B0", icon: "📰", label: "Sources" },
  ];

  const edgeTypes = [
    { type: "ownership", color: "#FF5722", label: "Ownership" },
    { type: "supply", color: "#4CAF50", label: "Supply Chain" },
    { type: "partnership", color: "#2196F3", label: "Partnership" },
    { type: "investment", color: "#FFC107", label: "Investment" },
    { type: "subsidiary", color: "#9C27B0", label: "Corporate Structure" },
    { type: "mentions", color: "#607D8B", label: "Media Mentions" },
  ];

  return (
    <Paper
      elevation={3}
      sx={{
        position: "absolute",
        bottom: 16,
        left: 16,
        p: 2,
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        backdropFilter: "blur(8px)",
        zIndex: 1000,
        minWidth: 220,
        maxHeight: "60vh",
        overflowY: "auto",
      }}
    >
      {/* Node Types Section */}
      <Typography variant="subtitle2" sx={{ color: "white", mb: 1 }}>
        Node Types
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
        {nodeTypes.map(({ type, color, icon, label }) => (
          <Box
            key={type}
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                backgroundColor: color,
              }}
            />
            <Typography variant="caption" sx={{ color: "white" }}>
              {icon} {label}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Edge Types Section */}
      <Typography variant="subtitle2" sx={{ color: "white", mb: 1 }}>
        Relationship Types
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {edgeTypes.map(({ type, color, label }) => (
          <Box
            key={type}
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            <Box
              sx={{
                width: 16,
                height: 2,
                backgroundColor: color,
                position: "relative",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  right: -4,
                  top: -2,
                  width: 0,
                  height: 0,
                  borderLeft: `4px solid ${color}`,
                  borderTop: "3px solid transparent",
                  borderBottom: "3px solid transparent",
                },
              }}
            />
            <Typography variant="caption" sx={{ color: "white" }}>
              {label}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Special Indicators */}
      <Box sx={{ mt: 2, pt: 1, borderTop: "1px solid rgba(255,255,255,0.2)" }}>
        <Typography
          variant="caption"
          sx={{ color: "white", fontStyle: "italic" }}
        >
          💛 Gold border = Seed entity
        </Typography>
      </Box>
    </Paper>
  );
};
